// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__TbULx","plus":"styles_plus__psn21","key":"styles_key__ASZ0U"};